/**
 * Google Ads + GA4 commerce catalog (marketing measurement).
 *
 * AW + GA4 gtag.js: deferred in index.html (idle) for CWV; Consent Mode denied until
 * CookieBanner accept. Accept calls ensureGtagLoaded() then initializeGA.
 * Display amounts approximate Stripe catalog for Smart Bidding — not a finance SoT.
 */

const SCHEMA_VERSION = '1.0.0';

/** Fallback matches Google Ads account tag; prefer REACT_APP_GOOGLE_ADS_ID. */
const DEFAULT_ADS_ID = 'AW-18481331415';

/** Fallback matches former index.html / gaEvents GA4 id. */
const DEFAULT_GA_MEASUREMENT_ID = 'G-LBZZX5TQWY';

/**
 * Catalog values used for GA4 begin_checkout / purchase (and optional Ads send_to).
 * Keep aligned with PricingPage JSON-LD + packPass DISPLAY_PRICE_JSON_LD / locales.
 */
const COMMERCE_CATALOG = Object.freeze({
  Pro: Object.freeze({
    item_id: 'pro_subscription',
    item_name: 'Architect-IQ Pro',
    pln: 39,
    eur: 11,
    usd: 11,
  }),
  pack_pass: Object.freeze({
    item_id: 'pack_pass',
    item_name: 'Architect-IQ report unlock',
    pln: 49,
    eur: 12,
    usd: 12,
  }),
});

function normalizeCurrency(currency) {
  const c = String(currency || 'usd').toLowerCase();
  if (c === 'pln' || c === 'eur' || c === 'usd') return c;
  return 'usd';
}

function resolveCommerceValue(sku, currency) {
  const row = COMMERCE_CATALOG[sku];
  if (!row) return null;
  const cur = normalizeCurrency(currency);
  const value = row[cur];
  if (typeof value !== 'number') return null;
  return {
    value,
    currency: cur.toUpperCase(),
    item_id: row.item_id,
    item_name: row.item_name,
  };
}

function resolveGaMeasurementId(env = typeof process !== 'undefined' ? process.env : {}) {
  return String(env.REACT_APP_GA_MEASUREMENT_ID || DEFAULT_GA_MEASUREMENT_ID).trim();
}

function resolveGoogleAdsId(env = typeof process !== 'undefined' ? process.env : {}) {
  return String(env.REACT_APP_GOOGLE_ADS_ID || DEFAULT_ADS_ID).trim();
}

/**
 * Optional conversion labels from Google Ads UI (AW-xxx/label).
 * Empty until ops paste labels after creating conversion actions.
 */
function resolveAdsConversionSendTo(kind, env = typeof process !== 'undefined' ? process.env : {}) {
  const map = {
    /** Primary Smart Bidding goal: new account (not a click). */
    sign_up: env.REACT_APP_GOOGLE_ADS_CONVERSION_SIGN_UP,
    purchase: env.REACT_APP_GOOGLE_ADS_CONVERSION_PURCHASE,
    pack_pass_purchase: env.REACT_APP_GOOGLE_ADS_CONVERSION_PACK_PASS,
    begin_checkout: env.REACT_APP_GOOGLE_ADS_CONVERSION_CHECKOUT,
  };
  const raw = String(map[kind] || '').trim();
  return raw || null;
}

module.exports = {
  SCHEMA_VERSION,
  DEFAULT_ADS_ID,
  DEFAULT_GA_MEASUREMENT_ID,
  COMMERCE_CATALOG,
  normalizeCurrency,
  resolveCommerceValue,
  resolveGaMeasurementId,
  resolveGoogleAdsId,
  resolveAdsConversionSendTo,
};
